<template>
  <div>
    <SearchBar :checkList="checkList" />
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      @selection-change="handleSelectionChange"
      fit
      highlight-current-row
      height="750"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" width="60" label="编号">
        <template slot-scope="scope">
          {{ pageSize * (pageIndex - 1) + (scope.$index + 1) }}
        </template>
      </el-table-column>

      <el-table-column label="用户名" align="center">
        <template slot-scope="scope">
          {{ handledecrypt(scope.row.nickName) }}
        </template>
      </el-table-column>

      <el-table-column label="公司名" align="center">
        <template slot-scope="scope">
          {{ scope.row.company || '无' }}
        </template>
      </el-table-column>
      <el-table-column label="电话号码" align="center">
        <template slot-scope="scope">
          {{ handledecrypt(scope.row.mobile, scope.row.isShowAllPhone) }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="待发放" align="center">
        <template slot-scope="scope">
          {{ scope.row.userBonus ? scope.row.userBonus.waitBonus : 0 }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="已发放" align="center">
        <template slot-scope="scope">
          {{ scope.row.userBonus ? scope.row.userBonus.issuedBonus : 0 }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="总佣金" align="center">
        <template slot-scope="scope">
          {{
            scope.row.userBonus
              ? scope.row.userBonus.issuedBonus + scope.row.userBonus.waitBonus
              : 0
          }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="已提取" align="center">
        <template slot-scope="scope">
          {{ scope.row.userBonus ? scope.row.userBonus.extractBonus : 0 }}
        </template>
      </el-table-column>

      <el-table-column
        class-name="status-col"
        label="操作"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            size="small"
            @click="toLookAwait(scope.row)"
            v-if="roleList[path].includes('To_be_issued')"
            >待发放</el-button
          >
          <el-button
            size="small"
            @click="toLookYet(scope.row)"
            v-if="roleList[path].includes('_Issued')"
            >已发放</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <Pagination ref="Pagination" />
  </div>
</template>

<script>
import { getUserBonusApi } from '@/api/money.js';
import SearchBar from './components/searchBar'; // 搜索框
import Pagination from '@/components/Pagination'; // 分页
import { mapGetters } from 'vuex';
import { decrypt } from '@/utils/encryp';

export default {
  components: {
    SearchBar,
    Pagination,
  },
  data() {
    return {
      list: null,
      listLoading: false,
      pageSize: 0,
      pageIndex: 0,
      path: '',
      checkList: [],
    };
  },
  created() {
    this.fetchData();
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
  },
  computed: {
    ...mapGetters(['paginObj', 'roleList']),
  },

  watch: {
    // 当分页组件中页码或页容量发生改变时会重新发请求渲染页面
    paginObj: 'fetchData',
  },
  methods: {
    // 处理解密
    handledecrypt(str, isShowAllPhone = true) {
      // if (!str || str.indexOf('=') == -1) return str;
      let showStr = decrypt(str);
      return isShowAllPhone
        ? showStr
        : showStr.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    },
    // 请求表单数据
    async fetchData(obj = {}) {
      try {
        this.listLoading = true;
        const areaId = localStorage.getItem('areaId')
          ? JSON.parse(localStorage.getItem('areaId')).areaId
          : '';
        let res = await getUserBonusApi({
          pageSize: this.paginObj.pageSize,
          pageIndex: this.paginObj.pageIndex,
          areaId,
          ...obj,
        });
        let { pageSize, pageIndex, dataList, totalCount } = res.data;
        this.list = dataList;
        this.pageSize = pageSize;
        this.listLoading = false;
        this.pageIndex = pageIndex;
        this.$refs.Pagination.pageSize = pageSize;
        this.$refs.Pagination.pageIndex = pageIndex;
        this.$refs.Pagination.totalCount = totalCount;
      } catch (e) {
        window.console.log(e);
      }
    },

    toLookAwait(row) {
      if (row.userBonus === null) {
        return this.$message.error('无此数据！');
      }
      let bonusId = row.userBonus.bonusId;
      this.$router.push(`lookAwait?id=${bonusId}`);
    },

    toLookYet(row) {
      if (row.userBonus === null) {
        return this.$message.error('无此数据！');
      }
      let bonusId = row.userBonus.bonusId;
      this.$router.push(`lookYet?id=${bonusId}`);
    },
    handleSelectionChange(val) {
      this.checkList = val.map((item) => {
        return item.userId;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.btn {
  display: flex;
  align-items: center;
}
/deep/ .el-checkbox__input {
  margin-left: 10px;
}
</style>
